const productTypeMap = {
  'Producto Muy importante': 'AA',
  'Producto Tipo A': 'A',
  'Producto Tipo B': 'B',
  'Producto Tipo C': 'C',
  'Producto Nuevo': 'BN',
  'Lento Movimiento': 'D',
  'Liquidacion': 'L',
  'Pedido Especial': 'PE',
  'Suministros': 'SUMINISTRO',
  'Instalaciones': 'INST',
  'I+D': 'I+D',
  'Producto Tipo C1': 'C1',
  'Producto Tipo C2': 'C2',
  'Producto Tipo C3': 'C3',
  'Producto Tipo CD': 'CD',
  'Producto Tipo CN': 'CN',
  'Demo': 'DEMO',
  'PK Stock': 'PK Stock',
}

export default productTypeMap